var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"landing"}},[_c('sign-in'),_c('button',{staticClass:"btn sml outline",on:{"click":_vm.createRoom}},[_vm._v(_vm._s(_vm.btnText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }